export const ASVP = 'ASVP';
export const CVP = 'CVP';



// WEBPACK FOOTER //
// ./src/common/constants/video-player-type.js